import BaseModelAPI from '../BaseModelAPI';

export default class ApproverType extends BaseModelAPI {
	static entity = 'approvertype';
	static entityName = 'approvertype';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.name = '';
			this.description = '';
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}